var page = '';

/**
 * CARREGA PACOTES AO INICIAR
 */
function packagesOnloadHome() {
    $(window).ready(function() {
        page = 'home';

        var urlParts = getUrlParameter();
        if (urlParts[4] == 'filtros') {
            packagesFilterControl(urlParts[6], urlParts[7])
            packagesLoader(packagesQtyInit, urlParts[6], urlParts[7]);
            return;
        }
        packagesLoader(packagesQtyInit);
    });
}

/**
 *
 */
function packagesOnloadDestiny() {
    $(window).ready(function() {
        page = 'destiny';

        packagesLoader(packagesQtyInitDestiny, 'city', $('#filterBy').val(), false);
    });
}



/**
 * TEXTO DO INICIO DOS PACOTES
 * @type {string}
 */
var packagesInitLabel = '' +
    '<div class="col-12 col-md-6 col-lg-4 col-xl-3">' +
    '<h2 class="packages__text text-center text-md-end">' +
    'Pacotes de <br class="d-none d-md-block">' +
    '<span class="text-warning"><b>hospedagem</b></span> <br>' +
    '<b>+</b> <span class="text-warning"><b>ingressos</b></span> <br class="d-none d-md-block">' +
    'do Thermas' +
    '</h2>' +
    '</div>';

var packagesInitLabelDestiny = '' +
    '<div class="col-12 col-md-6 col-lg-4 col-xl-3">' +
    '<h2 class="packages__text text-center text-md-end">' +
    'Pacotes de <br class="d-none d-md-block"> hospedagem <br>' +
    'em ' + $('#filterBy').val() + '<br>' +
    '<b><span class="text-warning">+ ingressos <br class="d-none d-md-block"> do Thermas<b/></span>' +
    '</h2>' +
    '</div>';


/**
 * FILTROS (click)
 */
$("body").on("click", "[data-packages-filter]", function(e) {
    e.preventDefault();
    var data = $(this).data();
    var filter = data.packagesFilter;

    packagesFilterControl(filter);

    if (filter == 'price' || filter == 'type' || filter == 'city' || filter == 'period') {
        return;
    }

    //atualizar variaveis
    breakpoints();
    packagesLoader(packagesQtyInit, filter);
});

/**
 * CONTROLE DE ESTADO DOS FILTROS
 * @param filter
 */
function packagesFilterControl(filter, filterBy) {

    //remoção do filtro por
    $('#filterByPrice').addClass('d-none');
    $('#filterByType').addClass('d-none');
    $('#filterByCity').addClass('d-none');
    $('#filterByPeriod').addClass('d-none');

    //ativação do filtro
    $("[data-packages-filter]").removeClass('nav-item-active');
    $("[data-packages-filter='" + filter + "']").addClass('nav-item-active');

    //abre filtro por
    if (filter == 'price') {
        $('#filterByPrice').removeClass('d-none');
    }
    if (filter == 'type') {
        $('#filterByType').removeClass('d-none');
    }
    if (filter == 'city') {
        $('#filterByCity').removeClass('d-none');
    }
    if (filter == 'period') {
        $('#filterByPeriod').removeClass('d-none');
    }

    //removoção de ativação de botão dos filter by
    $('[data-packages-filter-by]').removeClass('active');

    if (filterBy != undefined) {
        $("[data-packages-filter-by-value='" + filterBy + "']").addClass('active');
    }
}

/**
 * ALTERAÇÃO DE URL ATRÁVES DOS FILTROS
 * @param filter
 * @param filterBy
 */
function changeUrl(filter, filterBy) {
    if (filterBy != undefined) {
        history.pushState('', '', url(CONF_URL_FREEPASS + '/filtros/by/' + filter + '/' + filterBy));
        return;
    } else {
        if (filter != undefined && filter != 'booking') {
            history.pushState('', '', url(CONF_URL_FREEPASS + '/filtros/by/' + filter));
            return;
        }
    }
    history.pushState('', '', url(CONF_URL_FREEPASS));
}

/**
 * FILTRAR POR (click)
 */
$("body").on("click", "[data-packages-filter-by]", function(e) {
    e.preventDefault();
    var data = $(this).data();
    var filter = data.packagesFilterBy;
    var filterBy = data.packagesFilterByValue;

    //ativação do botão
    $('[data-packages-filter-by]').removeClass('active');
    $(this).addClass('active');

    //atualizar variaveis
    breakpoints();
    packagesLoader(packagesQtyInit, filter, filterBy);
});

/**
 * VER MAIS PACOTES
 */
$("body").on("click", "#btnPackagesViewMore", function(e) {
    e.preventDefault();
    var qty;
    if (page == 'home') {
        qty = packagesQtyViewMore;
    }
    if (page == 'destiny') {
        qty = packagesQtyViewMoreDestiny;
    }
    packagesLoader(qty, $('#filter').val(), $('#filterBy').val(), true);
});


/**
 * CARREGADOR DE PACOTES
 * @param qty
 * @param filter
 * @param filterBy
 */
function packagesLoader(qty, filter, filterBy, append = false) {

    if (append == false) {
        clearCount();
        clearLoaded();
    }

    var packagesLoad = $('#packagesLoad');
    var packagesLoaded = $('#loaded').val();

    $.ajax({
        url: url(CONF_URL_FREEPASS + '/carregar-pacotes'),
        data: 'qty=' + qty + '&filter=' + filter + '&filterBy=' + filterBy + '&loaded=' + packagesLoaded,
        type: 'POST',
        dataType: 'JSON',
        cache:false,
        beforeSend: () => {
            //loader
            loaderShow();
        },
        success: (response) => {

            if (page == 'home') {
                changeUrl(filter, filterBy);
            }

            //error
            if (response.message) {
                packagesLoad.html('');
            }

            if (response.packages) {

                if (append == false) {
                    packagesLoad.html('');
                    if (page == 'home') {
                        packagesLoad.append(packagesInitLabel);
                    }
                    if (page == 'destiny') {
                        packagesLoad.append(packagesInitLabelDestiny);
                    }
                }

                var boxStart = '<div class="col-12 col-md-6 col-lg-4 col-xl-3">';
                var boxEnd = '</div>';

                $.each(response.packages, function (index, pack) {
                    packagesLoad.append(boxStart + pack + boxEnd);
                });
            } else {
                packagesLoad.html(
                    '<div class="col-12 col-lg-8 offset-lg-2 col-xl-4 offset-xl-4 text-center py-5">' +
                    '<p class="text-center text-primary lead">Não encontramos pacotes de hospedagem com parque já incluso, mas você pode comprar seu ingresso e curtir  com a gente!</p>' +
                    '<a href="' + url(CONF_URL_TICKET) + '" class="btn btn-style-1">Comprar Ingressos</a>' +
                    '</div>'
                );
            }

            //set inputs
            setTypeFilter(filter);
            setTypeFilterBy(filterBy);
            addCountLoad(response.countLoad);
            setCountAll(response.countAll);
            setLoaded(response.loaded);
            btnPackagesViewMoreUpdate();

            loaderClose();
        }
    });
}

/**
 * ATUALIZAÇÃO DA VISUALIZAÇÂO DO BOTÂO VER MAIS
 */
function btnPackagesViewMoreUpdate() {
    var btn = $('#btnPackagesViewMore');
    var countLoad = parseInt($('#countLoad').val());
    var countAll = parseInt($('#countAll').val());

    console.log(countAll)

    if (countAll == 0) {
        btn.addClass('d-none');
        return;
    }

    if (countAll <= countLoad) {
        btn.addClass('d-none');
        return;
    }
    btn.removeClass('d-none');
}

// ALTERA VALOR DOS INPUTS HIDDEN
function setTypeFilter(value) {
    $('#filter').val(value);
}
function setTypeFilterBy(value) {
    $('#filterBr').val(value);
}
function addCountLoad(value) {
    var valueCountLoad = parseInt($('#countLoad').val());
    $('#countLoad').val(valueCountLoad + parseInt(value));
}
function setCountAll(value) {
    $('#countAll').val(value);
}
function clearCount() {
    $('#countLoad').val(0);
    $('#countAll').val(0);
}
function setLoaded(value) {
    $('#loaded').val(value);
}
function clearLoaded() {
    $('#loaded').val('');
}

